// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-page {
  background-color: var(--primary-color-light-200);
  margin-top: 0;
}
.dashboard-page__slider {
  background-color: var(--primary-color-light-500);
  width: 320px;
  position: fixed;
  top: 0;
  transform: translateX(-320px);
  transition: 0.3s;
  z-index: 900;
  height: 100%;
  padding: 0 20px;
}
.dashboard-page__slider.open {
  transition: transform 0.3s ease-in-out;
  box-shadow: 6px 2px 6px 0 rgba(109, 109, 109, 0.15);
  transform: translateX(0px);
}
@media (min-width: 1200px) {
  .dashboard-page .navbar {
    background-color: transparent;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/user/UserDashboardPage/UserDashboardPage.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;EACA,aAAA;AACF;AACE;EACE,gDAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACE,sCAAA;EACA,mDAAA;EACA,0BAAA;AACN;AAII;EADF;IAEI,6BAAA;EADJ;AACF","sourcesContent":[".dashboard-page {\n  background-color: var(--primary-color-light-200);\n  margin-top: 0;\n\n  &__slider {\n    background-color: var(--primary-color-light-500);\n    width: 320px;\n    position: fixed;\n    top: 0;\n    transform: translateX(-320px);\n    transition: .3s;\n    z-index: 900;\n    height: 100%;\n    padding: 0 20px;\n\n    &.open {\n      transition: transform .3s ease-in-out;\n      box-shadow: 6px 2px 6px 0 rgba(109, 109, 109, 0.15);\n      transform: translateX(0px);\n    }\n  }\n\n  .navbar {\n    @media (min-width: 1200px) {\n      background-color: transparent;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
